import { inject, Injectable } from '@angular/core'
import { FeathersService } from '../feathers.service'
import { Observable } from 'rxjs'
import { FeathersServiceStatus } from './feathersServiceStatus'
import { map } from 'rxjs/operators'

enum HealthCheckableServiceName {
  SMS = 'sms',
}

@Injectable({
  providedIn: 'root',
})
export class FeathersHealthCheckService {
  private feathers = inject(FeathersService)

  private healthServicePath = 'health'

  public checkServiceHealth(serviceName: HealthCheckableServiceName): Observable<FeathersServiceStatus> {
    return this.feathers
      .findOnGenericServiceWithOneRecordStore<FeathersServiceStatus>(this.healthServicePath, { name: serviceName })
      .pipe(map((res) => new FeathersServiceStatus(res)))
  }

  checkSmsHubHealth(): Observable<boolean> {
    return this.checkServiceHealth(HealthCheckableServiceName.SMS).pipe(
      map((status) => status.isGoodInLastTenMinutes()),
    )
  }
}
